import * as portalShared from "../shared/metadataConstantsAndUtilities";
import * as ddo from "../constants/customObjConstants";
import * as tag from "../constants/customMetadataConstants";
import * as showGroupUtil from "./showGroupUtilities";


// -----------------------------------------------------------------------------------------------------------------------------
// Add required question to dataDefObj
// -----------------------------------------------------------------------------------------------------------------------------

export const requiredCheck = (qnr, dataDefObj, pageObj, question, groupLikert = false, alignQuestionsAndAnswers = false, showGroupKey = "") => {

    // required resides as global and per page
    // Page is used to determine if NEXT is enabled
    // Global to determine if SUBMIT is enabled

    let helperTextArray = [""];

    if (question.questionType === portalShared.DATE_RANGE) {
        helperTextArray = ["",""];
    }

    if (question.questionType === portalShared.ADDRESS_FULL) {
        helperTextArray = ["","","","",""];
    }

    if (!question.optional) {

        // If question is NOT already in the requiredQuestions array then add it global
        if (!dataDefObj.requiredQuestions.some(x => x.id === question.id)) {
            dataDefObj.requiredQuestions.push(
                {
                    id: question.id,
                    questionType: question.questionType,
                    answered: false,
                    helperText: helperTextArray,
                    showGroupKey: showGroupKey
                }
            );
        }

        // If question is NOT already in the requiredQuestions array then add it to page
        if (!pageObj.requiredQuestions.some(x => x.id === question.id)) {
            pageObj.requiredQuestions.push(
                {
                    id: question.id,
                    questionType: question.questionType,
                    answered: false,
                    helperText: helperTextArray,
                    showGroupKey: showGroupKey
                }
            );
        }

        if ((pageObj.sections.length > 0) && !groupLikert) {

            let requiredSet = false;

            // Go backwards through sections/items looking for first item TITLE ?_NAME to put required asterisk
            for (let s = pageObj.sections.length-1; s >= 0; s--) {

                if (pageObj.sections[s].items.length > 0) {

                    for (let i = pageObj.sections[s].items.length-1; i >= 0; i--) {

                        let item = pageObj.sections[s].items[i];

                        let questionCustomObj = null;

                        // Check for question name aligned with answers
                        if (item.type === "QUESTION") {
                            //question = ddo.getQuestion(qnr, item.id);
                            if (tag.metadataExistsObj(question, portalShared.CUSTOM_DDO_QUE_FORMAT)) {
                                questionCustomObj = tag.metadataValueObj(question, portalShared.CUSTOM_DDO_QUE_FORMAT);
                                if (questionCustomObj.alignQuestionsAndAnswers) {
                                    // If question name is aligned then there will be no title object so required will go on the question item

                                    // item.requiredShowGroupKey = showGroupKey;
                                    // item.requiredIndicator = portalShared.REQUIRED_INDICATOR;
                                    // item.requiredIndicatorQuestionId = question.id;
                                    requiredSet = true;
                                }
                            }
                        } else if (alignQuestionsAndAnswers && item.type === ddo.OBJ.TYPE.SECTION_ITEM.LIKERT_QUESTION) {

                            // GROUP Likert question
                            // If question name is aligned then there will be no title object so required will go on the question item

                            // item.requiredShowGroupKey = showGroupKey;
                            // item.requiredIndicator = portalShared.REQUIRED_INDICATOR;
                            // item.requiredIndicatorQuestionId = question.id;
                            requiredSet = true;
                        }

                        // Look for first ?_NAME title to apply requires asterisk to, unless question name aligned with answers
                        if (!requiredSet && item.type === "TITLE" && item.source.includes("_NAME")) {
                            //debugger;
                            // item.requiredShowGroupKey = showGroupKey;
                            // item.requiredIndicator = portalShared.REQUIRED_INDICATOR;
                            // item.requiredIndicatorQuestionId = question.id;
                            requiredSet = true;
                            break;
                        }
                    }
                }

                if (requiredSet) {
                    break;
                }
            }
        }

    }
}

export const setRequiredAnsweredOnLoad = (question, dataDefObj, isInstance) => {

    // If a survey is reloaded with required questions already answered the Portal needs to set is answered
    // Template Mode (Portal Preview) NEVER saves data so no need to check
    if (isInstance && !question.optional) {

        switch (question.questionType) {
            case portalShared.ADDRESS_FULL:
                let addressObj = {address: "", extended: "", city: "", zipPostalCode: ""};

                if (question.hasOwnProperty("addressAnswerDTO") && portalShared.objExists(question.addressAnswerDTO)) {
                    addressObj = question.addressAnswerDTO;
                }

                if ((addressObj.address !== "") &&
                    (addressObj.extended !== "") &&
                    (addressObj.city !== "") &&
                    (addressObj.zipPostalCode !== "") && addressObj.zipPostalCode.length === 5) {

                    // If all text is populate then check to see if a state is selected
                    if (question.answerOptions.some(state => state.selected)) {
                        setRequiredAnswered("SRA-01", question.id, dataDefObj, true, ["","","","",""]);
                    }
                }

                break;
            case portalShared.DATE_RANGE:
                if (portalShared.objExists(question.answerText) && question.answerText !== "") {
                    let dates = question.answerText.split(",");
                    // Date range is stored in answerText as a comma delimited string ["start date","end date"]
                    if ((dates.length === 2) && (dates[0] !== "") && (dates[1] !== "")) {
                        setRequiredAnswered("SRA-02", question.id, dataDefObj, true, ["",""]);
                    }
                }
                break;
            case portalShared.YES_NO:
            case portalShared.RADIO:
            case portalShared.CHECKBOX:
            case portalShared.STATE_ONLY:
                if (question.answerOptions.some(answer => answer.selected)) {
                    setRequiredAnswered("SRA-03", question.id, dataDefObj, true, [""]);
                }
                break;
            case portalShared.FREE_TEXT:
            case portalShared.PHONE:
            case portalShared.CURRENCY:
            case portalShared.NUMBER:
            case portalShared.DATE:
                if (portalShared.objExists(question.answerText) && (question.answerText !== "")) {
                    setRequiredAnswered("SRA-04", question.id, dataDefObj, true, [""]);
                }
                break;
            case portalShared.EMAIL:

                if (portalShared.objExists(question.answerText) && (question.answerText !== "")) {

                    let validEmail = !!(question.answerText.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/) || question.answerText.length === 0);

                    setRequiredAnswered("SRA-05", question.id, dataDefObj, validEmail, validEmail ? [""] : ["Invalid email entry"]);
                }
                break;
            case portalShared.ZIPPOSTAL_ONLY:
                if (portalShared.objExists(question.answerText) && (question.answerText !== "") && (question.answerText.length === 5)) {
                    setRequiredAnswered("SRA-06", question.id, dataDefObj, true, [""]);
                }
                break;
            case portalShared.LIKERT_RADIO:
                // This one might need more is part of a group likert
                if (question.answerOptions.some(answer => answer.selected)) {
                    setRequiredAnswered("SRA-07", question.id, dataDefObj, true, [""]);
                }
                break;
            default:
                // Not a valid question type
                break;
        }
    }

}


export const setRequiredAnswered = (fromStr, questionId, dataDefObj, answered = true, helperText = [""]) => {

    for (let i = 0; i < dataDefObj.requiredQuestions.length; i++) {
        if (dataDefObj.requiredQuestions[i].id === questionId) {
            dataDefObj.requiredQuestions[i].answered = answered;
            dataDefObj.requiredQuestions[i].helperText = helperText;
            break;
        }
    }

    for (let p = 0; p < dataDefObj.pages.length; p++) {

        for (let i = 0; i < dataDefObj.pages[p].requiredQuestions.length; i++) {
            if (dataDefObj.pages[p].requiredQuestions[i].id === questionId) {
                dataDefObj.pages[p].requiredQuestions[i].answered = answered;
                dataDefObj.pages[p].requiredQuestions[i].helperText = helperText;
                break;
            }
        }
    }
}

export const getHelperText = (questionId, dataDefObj, index = 0) => {

    let helperText = "";

    for (let i = 0; i < dataDefObj.requiredQuestions.length; i++) {
        if (dataDefObj.requiredQuestions[i].id === questionId) {
            // helperText should be an array, but something is making it a string
            //if (typeof dataDefObj.requiredQuestions[i].helperText !== "string") {
                helperText = dataDefObj.requiredQuestions[i].helperText[index];
            //}
            break;
        }
    }

    return helperText;
}


export const setSingleAndMultiSelectRequiredAnswered = (question, answers, dataDefObj) => {

    let answered = false;

    for (let i = 0; i < answers.length; i++) {
        if (answers[i].selected) {
            answered = true;
            break;
        }
    }

    setRequiredAnswered("SRA-08", question.id, dataDefObj, answered);
}


export const buttonCheckForAllRequiredAnswered = (dataDefObj, qnr) => {

    let allRequiredAnswered = true;

    for (let i = 0; i < dataDefObj.requiredQuestions.length; i++) {
        if (!dataDefObj.requiredQuestions[i].answered) {
            // SSSSS Show Group
            // And is visible, show groups that are not visible do not count as not answered

            if (showGroupUtil.showGroup(qnr, dataDefObj.requiredQuestions[i].showGroupKey)) {

                allRequiredAnswered = false;
                break;
            }
        }
    }

    return  allRequiredAnswered;
}

export const buttonCheckForAllRequiredAnsweredOnPage = (dataDefObj, pageNum, qnr) => {

    let allRequiredAnsweredOnPage = true;

    for (let i = 0; i < dataDefObj.pages[pageNum].requiredQuestions.length; i++) {
        // If NOT answered
        if (!dataDefObj.pages[pageNum].requiredQuestions[i].answered) {
            // SSSSS Show Group
            // And is visible, show groups that are not visible do not count as not answered
            if (showGroupUtil.showGroup(qnr, dataDefObj.pages[pageNum].requiredQuestions[i].showGroupKey)) {
                allRequiredAnsweredOnPage = false;
                break;
            }
        }
    }

    return  allRequiredAnsweredOnPage;
}


export const isQuestionAnswered = (dataDefObj, itemObj, qnr) => {

    let isAnswered = false;

    // Title Item Object
    if (itemObj.hasOwnProperty("requiredIndicator")) {

        if (itemObj.requiredIndicator !== "") {
            for (let i = 0; i < dataDefObj.requiredQuestions.length; i++) {
                if ((dataDefObj.requiredQuestions[i].id === itemObj.requiredIndicatorQuestionId) && (dataDefObj.requiredQuestions[i].answered)) {
                    isAnswered = showGroupUtil.showGroup(qnr, itemObj.requiredShowGroupKey);
                    break;
                }
            }
        }

    }

    // Question Item Object
    if (itemObj.hasOwnProperty("required")) {

        for (let i = 0; i < dataDefObj.requiredQuestions.length; i++) {
            if ((dataDefObj.requiredQuestions[i].id === itemObj.id) && (dataDefObj.requiredQuestions[i].answered)) {
                isAnswered = showGroupUtil.showGroup(qnr, itemObj.requiredShowGroupKey);
                break;
            }
        }

    }

    return  isAnswered;
}

export const setAddressHelperText = (required, addressObj, stateArray, fromInputType = "text") => {

    let helperText = ["","","","",""];

    if (required) {

        let a = {address: "", extended: "", city: "", zipPostalCode: ""};

        if (portalShared.objExists(addressObj)) {
            a = addressObj;

            helperText[0] = (a.address.trim() === "") ? "Required." : "";

            helperText[2] = (a.city.trim() === "") ? "Required." : "";

            if (a.zipPostalCode.trim() === "") {
                helperText[4] = "Required.";
            } else if (a.zipPostalCode.trim().length !== 5) {
                helperText[4] = "5 digits required.";
            }
        } else {
            helperText = ["Required.","","Required.","Required.","Required."];
        }

        helperText[3] = (stateArray.some(state => state.selected)) ? "" : "Required.";

    }

    return helperText;
}


export const checkAddressToSeeIfAnswered = (helperTextArray, stateAnswered) => {

    let answered = true;

    // helperTextArray[1] is address extended and is NOT required
    if (helperTextArray[0] !== "") {
        answered = false;
    } else if (helperTextArray[2] !== "") {
        answered = false;
    } else if (helperTextArray[3] !== "") {
        answered = false;
    } else if (helperTextArray[4] !== "") {
        answered = false;
    } else if (!stateAnswered) {
        answered = false;
    }

    return answered;
}


export const handleRequiredTextAndDateQuestions = (question, tempDataDefObj) => {

    // Handled required questions ------------------------------------------------------
    // If required and answered then set required flag answered
    // answerText is undefined until null and undefined checks are needed because of the differences in instance/template mode
    if (!question.optional && portalShared.objExists(question.answerText) && (question.answerText.trim() !== "")) {
        if (question.questionType === portalShared.RANKING) {

            // If confirmed then setRequiredAnswered(question.id, tempDataDefObj);

        } else if (question.questionType === portalShared.DATE_RANGE) {

            // Date Ranges are stored as comma delimited string (From,To) i.e. "2026-05-01,2026-05-11"
            let dates = question.answerText.split(",");

            // If both dates answered and 2nd date is greater then 1st date then requirements meet
            if ((dates.length === 2) && (dates[0] !== "") && (dates[1] !== "") && (dates[1] > dates[0])) {
                setRequiredAnswered("SRA-09", question.id, tempDataDefObj, true, ["", ""]);
            } else if ((dates.length === 2) && (dates[0] !== "") && (dates[1] !== "") && (dates[1] < dates[0])) {
                setRequiredAnswered("SRA-09", question.id, tempDataDefObj, false, ["", "Date must be after other date."]);
            }
        } else if (question.questionType === portalShared.EMAIL) {
            let validEmailObj = validateEmail(question.answerText.trim());
            if (!validEmailObj.flag) {
                setRequiredAnswered("SRA-10", question.id, tempDataDefObj);
            }
        } else if (question.questionType === portalShared.PHONE) {
            if (question.answerText.trim() === 10) {
                setRequiredAnswered("SRA-11", question.id, tempDataDefObj);
            }
        } else if (question.questionType === portalShared.ZIPPOSTAL_ONLY) {
            if (question.answerText.trim() === 5) {
                setRequiredAnswered("SRA-12", question.id, tempDataDefObj);
            }
        } else {
            setRequiredAnswered("SRA-14", question.id, tempDataDefObj);
        }
    }
}


export const handleRequiredAddressQuestions = (question, addressObj, statesArray, fromInputType, dataDefObj) => {

    let helperText = setAddressHelperText(!question.optional, addressObj, statesArray, fromInputType);

    let stateSelected = statesArray.some(state => state.selected);

    let answered = checkAddressToSeeIfAnswered(helperText, stateSelected);

    setRequiredAnswered("SRA-15", question.id, dataDefObj, answered, helperText);

}


export const handleRequired = (question, addressObj, statesArray, fromInputType, dataDefObj) => {

    if (!question.optional) {

        // If it's an address then this must be the state DDBL
        if (question.questionType === portalShared.ADDRESS_FULL) {

            let helperText = setAddressHelperText(!question.optional, addressObj, statesArray, fromInputType);

            let answered = checkAddressToSeeIfAnswered(helperText, true);

            setRequiredAnswered("SRA-17", question.id, dataDefObj, answered, helperText);

        } else {
            setSingleAndMultiSelectRequiredAnswered(question, statesArray, dataDefObj);
        }
    }

}


export const  validateEmail = (answerText) => {
    // regex checks for one and only 1 '@'
    // no white space in the email
    // at least one character before the '@', between the '@' and the '.'
    // and one or more characters after the '.'

    let tempEmail = (answerText === null || answerText === undefined) ? "" : answerText;

    let errorFlag = !!(tempEmail.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/) || tempEmail.length === 0);

    let errorMessage = !errorFlag ? "Invalid email entry" : "";

    return {flag: !errorFlag, message: errorMessage};
}


export const  getRequiredIndicatorFontSize = (titleFontSize) => {

    let fontPoints = Number(titleFontSize.replace("pt", ""));

    return Math.floor(fontPoints * .65) + "pt";
}